module.exports = __webpack_public_path__ + "media/images/country_flags/lv-73ee75998a08ff328eeb4ec89f4efe4e.png";